import { animate, query, stagger, state, style, transition, trigger } from '@angular/animations'

export const slideInOutAnimation = trigger('slideInOutAnimation', [
  state(
    'enter',
    style({
      left: '-100%',
      opacity: 0,
    }),
  ),
  state(
    'stable',
    style({
      left: '0%',
      opacity: 1,
    }),
  ),
  state(
    'leave',
    style({
      left: '-100%',
      opacity: 0,
    }),
  ),
  transition('enter => stable', [animate('0.5s ease-in-out')]),
  transition('stable => leave', [animate('0.5s ease-in-out')]),
  transition('leave => enter', [animate('0.5s ease-in-out')]),
])

export const fadeIn = trigger('fadeIn', [
  transition(':enter', [
    style({ opacity: 0 }),
    animate('200ms', style({ opacity: 1 })),
  ]),
])

export const fadeInOut = trigger('fadeInOut', [
  state('in', style({ opacity: 1 })),
  transition(':enter', [style({ opacity: 0 }), animate(100)]),
  transition(':leave', animate(100, style({ opacity: 0 }))),
])

export const listAnimation = trigger('listAnimation', [
  transition('* <=> *', [
    query(':enter', [
      style({ opacity: 0, transform: 'translateY(-15px)' }),
      stagger('50ms', animate('200ms ease-out', style({ opacity: 1, transform: 'translateY(0px)' })))
    ], { optional: true })
  ])
])

export const tabAnimation = trigger('tabAnimation', [
  transition(':enter', [style({ opacity: 0 }), animate('200ms', style({ opacity: 1 }))]),
  transition(':leave', [animate('200ms', style({ opacity: 0 }))]),
])

export const slideInRight = trigger('slideInRight', [
  transition(':enter', [
    style({ transform: 'translateX(100%)', opacity: 0 }),
    animate('250ms ease-out', style({ transform: 'translateX(0)', opacity: 1 })),
  ]),
  transition(':leave', [
    animate('250ms ease-in', style({ transform: 'translateX(100%)', opacity: 0 })),
  ]),
])

export const growAnimation = trigger('growAnimation', [
  transition(':enter', [
    style({ height: '0px', opacity: 0, overflow: 'hidden' }),
    animate('100ms ease-out', style({ height: '*', opacity: 1 })),
  ]),
  transition(':leave', [
    animate('100ms ease-in', style({ height: '0px', opacity: 0, overflow: 'hidden' })),
  ]),
])